import { API } from '../utils/constants'

const services = {
  list: API + '/oportunities',
  delete: API + '/oportunities',
  detail: API + '/oportunities',
  register: API + '/oportunities',
  status: API + '/oportunities/status',
  approved: API + '/oportunities/approved',
  generate: API + '/oportunities/generate',
}

export async function getAllOportunities(params?: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(
    params
      ? `${services.list}?start_date=${params.start ?? ''}&end_date=${params.end ?? ''}&status=${params.status ?? ''}`
      : services.list,
    requestOptions,
  ).then((response) => {
    res = response.json()
  })

  return res
}

export async function getOportunitiesStatuses() {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(services.status, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function getApproved() {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(services.approved, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function sendQuotationToMail(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${services.list}/send/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function updateQuotationStatus(body: any, id: number) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(`${services.status}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function generateNewQuotation(body: any, id: number) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(`${services.generate}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function deleteOportunity(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'DELETE',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${services.delete}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function newOportunity(body: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(services.register, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function updateQuotation(id: any, body: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'PUT',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
    body: JSON.stringify(body),
  }
  let res: any = null

  await fetch(`${services.register}/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}

export async function getQuotationsByContactId(id: any) {
  const _token = localStorage.getItem('__token')
  const requestOptions = {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
      Authorization: 'Bearer ' + _token,
    },
  }
  let res: any = null

  await fetch(`${services.register}/by-contact/${id}`, requestOptions).then((response) => {
    res = response.json()
  })

  return res
}
